import type { FC } from 'react';

import { Badge } from '@mui/material';

import { Add, FilterNew, Search } from '@shared/assets';
import { IconButton } from '@shared/ui';

import { UserList } from '@src/features/messenger';

import * as st from './styles.module.scss';

export const MessengerActions: FC = () => {
	return (
		<div className={st.action}>
			<div className={st.header}>
				<div>
					<IconButton variant={'dark'}>
						<Search />
					</IconButton>
				</div>

				<IconButton variant={'dark'}>
					<FilterNew />
				</IconButton>

				<IconButton variant={'dark'}>
					<Add />
				</IconButton>
			</div>

			<div className={st.helper}>
				<div className={st.badge}>
					<Badge badgeContent={8} />
				</div>
				<button className={st.btn} type="button">
					Выбрать
				</button>
			</div>
			<div className={st.list}>
				<UserList />
			</div>
		</div>
	);
};
